import { connect } from 'react-redux'
import { IGlobalState } from '../../Root/store/appReducer'
import YumActivityFilter, { IYumActivityFilterDispatchProps, IYumActivityFilterProps } from './YumActivityFilter'
import {
  getCurrentGoalActivityList,
  getCurrentGoalActivityListClear,
  setActivityFilter,
  setGroupView,
} from '../../views/Activity/store/ActivityActions'
//import { getDivisionsDeprecated } from '../../views/TeamManagement/store/TeamManagementActions'
//import { getDivisionsSelectorDeprecated as getDivisionsSelector } from '../../views/TeamManagement/store/TeamManagementSelectors'
import { getCompanyDivisions } from '../../views/Settings/store/SettingsActions'

const mapStateToProps = (state: IGlobalState, ownProps: IYumActivityFilterProps): IYumActivityFilterProps => {
  return {
    ...ownProps,
    //companyGroups: getDivisionsSelector(state) || {},
  }
}

const mapDispatchToProps: IYumActivityFilterDispatchProps = {
  setActivityFilter,
  getCurrentGoalActivityListClear,
  getCurrentGoalActivityList,
  setGroupView,
  getDivisions: getCompanyDivisions,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumActivityFilter)
